var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _path8, _path9, _path10, _path11, _circle4, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowToWriteABlogPost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 780,
    height: 440,
    viewBox: "0 0 780 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "how-to-write-a-blog-post") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#083f3f",
    d: "M0 0h780v440H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c9faf0",
    d: "M218.9 105.5h390v250h-390z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M301.2 151.5h225.4V355H301.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.9 85.5h380a5 5 0 0 1 5 5v15h-390v-15a5 5 0 0 1 5-5z",
    fill: "#067c7c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0b968f",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M331.2 181h53.7M331.2 201h3.7M331.2 211h3.7M331.2 221h3.7M331.2 241h154.4M331.2 251h148.7M331.2 261h158.4M331.2 271h154.4M331.2 281h152.4M331.2 291h154.4M331.2 311h152.4M331.2 321h154.4M331.2 331h156.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7dead5",
    d: "M424.9 197.5h41v7h-41zM394.9 207.5h41v7h-41z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0b968f",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M341.2 201h139.7M341.2 211h148.7M341.2 221h132.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 232.6,
    cy: 95.5,
    r: 3,
    fill: "#0b968f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.6,
    cy: 95.5,
    r: 3,
    fill: "#0b968f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.6,
    cy: 95.5,
    r: 3,
    fill: "#0b968f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M534.9 180.5h59v78h-59z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0b968f",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M542.2 195h41.1M542.2 205h43.7M542.2 215h39M542.2 225h43.7M542.2 235h43.7M542.2 245h39"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#7dead5",
    d: "M555.1 280.5h91v91h-91z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0b968f",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M568.5 299.3l54.7-2.2M568.9 309.3l63.6-2.5M569.3 319.3l47.6-1.9M577.9 342l48.4 2.1M577.5 352l55 2.3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 610.1,
    cy: 303,
    r: 10.5,
    fill: "none",
    stroke: "#c9faf0",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#08c4b2",
    d: "M133.9 120.5h121v254h-121z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0b968f",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M154.2 147h80.7M154.2 137H191M154.2 177H199M154.2 217H193M154.2 257H207M154.2 297H193M154.2 337H201M154.2 157h64.7M154.2 187h80.7M154.2 197h74.7M154.2 227h80.7M154.2 237H231M154.2 267h80.7M154.2 277h64.7M154.2 307h80.7M154.2 317H231M154.2 347h80.7M154.2 357H227"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToWriteABlogPost);
export default __webpack_public_path__ + "static/media/how-to-write-a-blog-post.d9a5c061db64a490f3a9af77649767b5.svg";
export { ForwardRef as ReactComponent };